import type { GetBillingCyclePageResponse } from '@vy/api-definition';
import { GetBillingCyclePageResponseSchema } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

type BillingCyclePagePayload = Parameters<WeftApi['getBillingCyclePage']>[0];

export function useBillingCyclePage(
  payload: BillingCyclePagePayload = {},
  options?: CustomUseQueryOptions<GetBillingCyclePageResponse>,
) {
  const billingCyclePageQuery = useQuery({
    queryKey: queryKeys.billingCyclePage(...Object.values(payload)),
    queryFn: async ({ signal }) => {
      const api = getPrivateApi();
      const getBillingCyclePageResponse = await api.getBillingCyclePage(payload, { signal });

      return GetBillingCyclePageResponseSchema.parse(getBillingCyclePageResponse);
    },
    keepPreviousData: true,
    ...options,
  });

  return billingCyclePageQuery;
}
